import React from 'react'
import './spinner.css'



function Spinner({ star, className, height = '20vh' }) {
    return (
        <div className={`w-100 flex justify-center items-center mx-auto`} style={{ height: height }} >
            <div className="loader ">
            </div>
        </div>
    )
}

export default Spinner